// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1UaOU","item":"PaymentsMobile_item__1OgvP","label":"PaymentsMobile_label__2hwu3","amount":"PaymentsMobile_amount__3f4hj"};